// @flow
import reducer from './reducer';
import actions from './actions';
import * as selectors from './selectors';

export { reducer, actions, selectors };



// WEBPACK FOOTER //
// ./src/store/reducers/user/personInfo/index.js